var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-indicator',{attrs:{"loading":_vm.loading}},[_c('root-cause-list',{attrs:{"investigationId":_vm.id,"categories":_vm.rootCauseCategories,"disabled":_vm.listDisabled},on:{"answer-toggled":_vm.getRootCauses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }